import './animation';
import Dispatcher from './dispatcher';
import Excuse from './views/excuse';
import Home from './views/home';
import Transition from './transition';
import Utils from './utils';

const Barba = require('barba.js');
const FastClick = require('fastclick');

require('jquery-inview');
require('../scss/app.scss');


window.$ = $;

$(document).ready(() => {
    Home.init();
    Excuse.init();

    new Dispatcher();

    Barba.Pjax.start();

    new Transition();

    Barba.Prefetch.init();
});

FastClick.attach(document.body);

/* eslint-disable */
window._wq = window._wq || [];
_wq.push({
    id: '_all',
    onReady(video) {
        $(video.container).on('inview', (event, isInView) => {
            if (Utils.isMobile()) {
                return;
            }

            if (isInView && video.state() !== 'ended') {
                video.play();
            } else {
                video.pause();
            }
        });
    }
});



// WEBPACK FOOTER //
// ./frontend/js/app.js